import {AbstractControl} from '@angular/forms';

export function hasRequiredValidator(control: AbstractControl): boolean {
  const errors = control.validator !== null ? control.validator({} as AbstractControl) : null;

  return errors !== null && errors.required === true;
}
